import React from "react";
import { useCategory } from "@elevio/kb-kit/lib/hooks";
import * as Article from "@elevio/kb-kit/lib/components/article";
import * as Articles from "@elevio/kb-kit/lib/components/articles";
import { faqArticleIds } from "../utils/constants";
function ArticleList({ className, isRelated }) {
    const category = useCategory({ usePageCategory: false });
    const HeadingTag = 'h2';
    return (<div className={className}>
      <HeadingTag className={!isRelated ? 'home-article-title' : 'related-articles'}>
      {isRelated ? 'Related Articles' : category && category.title}
      </HeadingTag>
      <ul className="article-list">
        {isRelated ? (<Articles.Loop>
            <li className="article-list-item home-article-info">
              <Article.Link className="article-list-link" aria-label="View article">
                <Article.Title />
              </Article.Link>
            </li>
          </Articles.Loop>) : (faqArticleIds.map((article) => (<li className="article-list-item home-article-info" key={article}>
              <Article.Link articleId={article} className="article-list-link" aria-label="View FAQ article">
                <Article.Title articleId={article}/>
              </Article.Link>
            </li>)))}
      </ul>
    </div>);
}
export default ArticleList;
